export const Trash = ({
    fill = '#FFBE38',
    width = '28',
    height = '28',
}: {
    fill?: string
    width?: string
    height?: string
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.3335 9H20.6668M19.0002 9V18.8333C19.0002 19.7668 19.0003 20.2335 18.8187 20.59C18.6589 20.9036 18.4036 21.1585 18.09 21.3183C17.7335 21.5 17.2671 21.5 16.3337 21.5H11.667C10.7336 21.5 10.2665 21.5 9.90999 21.3183C9.59639 21.1585 9.34161 20.9036 9.18182 20.59C9.00016 20.2335 9.00016 19.7668 9.00016 18.8333V9H19.0002ZM17.3335 9H10.6668C10.6668 8.22343 10.6668 7.83513 10.7937 7.52885C10.9629 7.12047 11.2871 6.79602 11.6955 6.62687C12.0018 6.5 12.3903 6.5 13.1668 6.5H14.8335C15.6101 6.5 15.9984 6.5 16.3046 6.62687C16.713 6.79602 17.0374 7.12047 17.2065 7.52885C17.3334 7.83513 17.3335 8.22343 17.3335 9Z"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
